/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Nodata1Inputs */

const he_item_stats_nodata1 = /** @type {(inputs: Item_Stats_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין נתוני מחיר`)
};

const en_item_stats_nodata1 = /** @type {(inputs: Item_Stats_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No price data`)
};

/**
* | output |
* | --- |
* | "No price data" |
*
* @param {Item_Stats_Nodata1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_nodata1 = /** @type {((inputs?: Item_Stats_Nodata1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Nodata1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_nodata1(inputs)
	return en_item_stats_nodata1(inputs)
});
export { item_stats_nodata1 as "item_stats_noData" }